import React, { Component } from 'react';
import Filter from '../index';

import './styles.css';

class FiltersContainer extends Component {
  state = {
    currentOpenedFilter: false,
  };

  _onFilter = (newValue, filterFunction) => {
    this._toggleOverlay(false);
    filterFunction(newValue);
  };

  _renderFilters = filters => {
    const {
      alwaysShowPlaceholder,
      isNextPageLoading,
      loadNextPage,
      currentFilters,
      isFetching,
      requestFilterOptions,
      fixedOptions,
      defaultAmount,
    } = this.props;
    return filters.map(filter => (
      <Filter
        isNextPageLoading={isNextPageLoading}
        loadNextPage={async (startIndex, stopIndex) => {
          if (filter.options.length >= defaultAmount) {
            await loadNextPage(filter.filterType, startIndex, stopIndex);
          }
        }}
        hasNextPage={
          currentFilters && currentFilters[filter.filterType]
            ? currentFilters[filter.filterType].hasNextPage
            : null
        }
        alwaysShowPlaceholder={alwaysShowPlaceholder}
        key={filter.identifier}
        identifier={filter.identifier}
        toggleOverlay={this._toggleOverlay}
        type={filter.type}
        enumerator={filter.enumerator}
        currentValue={filter.currentValue}
        options={filter.options}
        noMinWidth={filter.noMinWidth}
        scrollAuto={filter.scrollAuto}
        label={filter.currentValue || filter.label}
        isOpen={this.state.currentOpenedFilter === filter.identifier}
        placeholder={filter.placeholder}
        renderLeft={filter.renderLeft}
        onFilter={newValue => this._onFilter(newValue, filter.onFilter)}
        onSearchByTerm={filter.onSearchByTerm}
        searchTerm={
          currentFilters && currentFilters[filter.filterType]
            ? currentFilters[filter.filterType].searchTerm
            : null
        }
        isFetching={isFetching}
        requestFilterOptions={requestFilterOptions}
        fixedOptions={fixedOptions}
        itemSize={filter.itemSize}
        totalOptions={filter.totalOptions}
        customComponent={filter.customComponent}
        customComponentProps={filter.customComponentProps}
        customStyles={filter.customStyles}
      />
    ));
  };

  _toggleOverlay = filterName => {
    this.setState({ currentOpenedFilter: filterName || false });
  };

  render() {
    const { filters } = this.props;
    const { currentOpenedFilter } = this.state;

    return (
      <div className="FilterContainer__root">
        {currentOpenedFilter && (
          <div
            className="FilterContainer__overlay"
            onClick={() => this._toggleOverlay(false)}
          />
        )}
        {this._renderFilters(filters)}
      </div>
    );
  }
}

export default FiltersContainer;
